export class Paginator {
  private _count = 0;
  currentPage = 1;
  pageCount = 1;

  constructor(
    public countByPage = 50
  ) {
  }

  set count(value: number) {
    this._count = value;
    this.pageCount = Math.ceil(this._count / this.countByPage);
  }

  reset(): void {
    this.currentPage = 1;
  }
}
